import { render, staticRenderFns } from "./AndroidHealthDetails.vue?vue&type=template&id=d2784166&scoped=true"
import script from "./AndroidHealthDetails.vue?vue&type=script&lang=js"
export * from "./AndroidHealthDetails.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthDetails.vue?vue&type=style&index=0&id=d2784166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2784166",
  null
  
)

export default component.exports